const IconBookmarkOff = () => {
    return (
        <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
            <path d="M6 2h12a1 1 0 0 1 1 1v19l-7-4.5L5 22V3a1 1 0 0 1 1-1z" />
            <line x1="3" y1="3" x2="21" y2="21" stroke="#c0392b" strokeWidth="3" />
        </svg>
    );
}

export default IconBookmarkOff;
